import { useState, useEffect } from 'react';

const getScreenFlags = () => {
  if (typeof window === 'undefined') {
    return { isMobile: false, isTablet: false, isDesktop: true };
  }
  const width = window.innerWidth;
  if (width < 768) {
    return { isMobile: true, isTablet: false, isDesktop: false };
  }
  if (width >= 768 && width < 1024) {
    return { isMobile: false, isTablet: true, isDesktop: false };
  }
  return { isMobile: false, isTablet: false, isDesktop: true };
};

export const useResponsive = () => {
  const [screen, setScreen] = useState(getScreenFlags);

  useEffect(() => {
    const checkScreenSize = () => {
      setScreen(getScreenFlags());
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return {
    isMobile: screen.isMobile,
    isTablet: screen.isTablet,
    isDesktop: screen.isDesktop,
    screenSize: screen.isMobile ? 'mobile' : screen.isTablet ? 'tablet' : 'desktop',
  };
};
